import React from 'react';
import { Mail, Video, Crown, ChevronRight } from 'lucide-react';

export const GrandPStoryRequestsSection = ({ 
  queueRequests, 
  loadingQueue, 
  sectionsExpanded, 
  toggleSection, 
  navigate 
}) => {
  // Separate regular and premium requests
  console.log(queueRequests)
  const regularRequests = queueRequests.filter(r => !r.is_premium);
  const premiumRequests = queueRequests.filter(r => r.is_premium);

  return (
    <div style={{ marginBottom: '2rem' }}>
      <div 
        style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between', 
          cursor: 'pointer',
          marginBottom: sectionsExpanded.storyRequests ? '1rem' : '0'
        }}
        onClick={() => toggleSection('storyRequests')}
      >
        <h4 style={{ 
          fontSize: '1.125rem', 
          fontWeight: '600', 
          color: '#7c3aed', 
          display: 'flex', 
          alignItems: 'center', 
          gap: '0.5rem' 
        }}>
          <Mail size={20} />
          Story Requests from Parents ({queueRequests.length})
        </h4>
        <ChevronRight 
          size={20} 
          style={{ 
            transform: sectionsExpanded.storyRequests ? 'rotate(90deg)' : 'rotate(0deg)', 
            transition: 'transform 0.2s' 
          }} 
        />
      </div>
      
      {sectionsExpanded.storyRequests && (
        <div>
          {loadingQueue ? (
            <p style={{ color: '#6b7280', fontStyle: 'italic' }}>Loading requests...</p>
          ) : queueRequests.length === 0 ? (
            <p style={{ color: '#6b7280', fontStyle: 'italic' }}>No story requests yet</p>
          ) : (
            <>
              {/* Premium Requests Section */}
              {premiumRequests.length > 0 && (
                <div style={{ marginBottom: '1.5rem' }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    marginBottom: '1rem',
                    padding: '0.5rem 0',
                    borderBottom: '2px solid #fbbf24'
                  }}>
                    <Crown size={20} style={{ color: '#f59e0b' }} />
                    <h5 style={{ 
                      fontSize: '1rem', 
                      fontWeight: '600', 
                      color: '#f59e0b',
                      margin: 0
                    }}>
                      Premium Requests ({premiumRequests.length})
                    </h5>
                  </div>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    {premiumRequests.map(request => (
                      <div 
                        key={request.id} 
                        style={{
                          border: '2px solid #fbbf24',
                          borderRadius: '0.75rem',
                          padding: '1rem',
                          background: 'linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)',
                          position: 'relative'
                        }}
                      >
                        {/* Premium Badge */}
                        <div style={{
                          position: 'absolute',
                          top: '0.75rem',
                          right: '0.75rem',
                          background: 'linear-gradient(135deg, #fbbf24, #f59e0b)',
                          color: 'white',
                          padding: '0.25rem 0.5rem',
                          borderRadius: '0.25rem',
                          fontSize: '0.625rem',
                          fontWeight: '700',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.25rem'
                        }}>
                          <Crown size={10} />
                          PREMIUM
                        </div>

                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                          <div style={{ flex: 1, paddingRight: '4rem' }}>
                            <h5 style={{ 
                              fontWeight: '600', 
                              fontSize: '1.125rem', 
                              marginBottom: '0.25rem',
                              color: '#92400e'
                            }}>
                              {request.book?.title || 'Unknown Book'}
                            </h5>
                            <p style={{ 
                              fontSize: '0.875rem', 
                              color: '#92400e', 
                              marginBottom: '0.5rem' 
                            }}>
                              by {request.book?.author || 'Unknown'}
                            </p>
                            <p style={{ fontSize: '0.75rem', color: '#78350f' }}>
                              For: {request.kid?.name} ({request.kid?.family_name})
                            </p>
                            <p style={{ 
                              fontSize: '0.75rem', 
                              color: '#78350f', 
                              marginTop: '0.25rem' 
                            }}>
                              Requested by: {request.requested_by?.name}
                            </p>
                          </div>
                          <button
                          onClick={() => navigate(`/book/${request.book_id}?premium=true&childId=${request.kid_id}`)}
                            style={{
                              background: 'linear-gradient(135deg, #fbbf24, #f59e0b)',
                              color: 'white',
                              border: 'none',
                              borderRadius: '0.5rem',
                              padding: '0.75rem 1rem',
                              fontWeight: '600',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.5rem',
                              fontSize: '0.875rem',
                              whiteSpace: 'nowrap',
                              transition: 'transform 0.2s'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                          >
                            Record Story <Video size={16} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Regular Requests Section */}
              {regularRequests.length > 0 && (
                <div>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    marginBottom: '1rem',
                    padding: '0.5rem 0',
                    borderBottom: '2px solid #e5e7eb'
                  }}>
                    <Mail size={20} style={{ color: '#7c3aed' }} />
                    <h5 style={{ 
                      fontSize: '1rem', 
                      fontWeight: '600', 
                      color: '#7c3aed',
                      margin: 0
                    }}>
                      Regular Requests ({regularRequests.length})
                    </h5>
                  </div>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    {regularRequests.map(request => (
                      <div 
                        key={request.id} 
                        style={{
                          border: '1px solid #e5e7eb',
                          borderRadius: '0.75rem',
                          padding: '1rem',
                          background: 'white'
                        }}
                      >
                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                          <div style={{ flex: 1 }}>
                            <h5 style={{ 
                              fontWeight: '600', 
                              fontSize: '1.125rem', 
                              marginBottom: '0.25rem' 
                            }}>
                              {request.book?.title || 'Unknown Book'}
                            </h5>
                            <p style={{ 
                              fontSize: '0.875rem', 
                              color: '#6b7280', 
                              marginBottom: '0.5rem' 
                            }}>
                              by {request.book?.author || 'Unknown'}
                            </p>
                            <p style={{ fontSize: '0.75rem', color: '#9ca3af' }}>
                              For: {request.kid?.name} ({request.kid?.family_name})
                            </p>
                            <p style={{ 
                              fontSize: '0.75rem', 
                              color: '#9ca3af', 
                              marginTop: '0.25rem' 
                            }}>
                              Requested by: {request.requested_by?.name}
                            </p>
                          </div>
                          <button
                            onClick={() => navigate(`/book/${request.book_id}?childId=${request.kid_id}`)}
                            style={{
                              background: '#7c3aed',
                              color: 'white',
                              border: 'none',
                              borderRadius: '0.5rem',
                              padding: '0.75rem 1rem',
                              fontWeight: '600',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.5rem',
                              fontSize: '0.875rem',
                              whiteSpace: 'nowrap',
                              transition: 'background-color 0.2s'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.background = '#6d28d9'}
                            onMouseLeave={(e) => e.currentTarget.style.background = '#7c3aed'}
                          >
                            Record Story <Video size={16} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};